import { render } from "./ModalEditPayment.vue?vue&type=template&id=19efd807&scoped=true"
import script from "./ModalEditPayment.vue?vue&type=script&lang=js"
export * from "./ModalEditPayment.vue?vue&type=script&lang=js"

import "./ModalEditPayment.vue?vue&type=style&index=0&id=19efd807&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19efd807"]])

export default __exports__